// places/index.js
import AdminsContainer from './AdminsContainer';

export default { AdminsContainer };
